class Datetime {
    /**
     * return date minus "x" days
     *
     * @param timeOffset: Offset zwischen Server- und Client-Zeitstempel in ms
     * @param dayMinusX: zurückliegender Tag
     */
    getDateMinusX(timeOffset, dayMinusX) {
        const date = this.getSystemDateTime(timeOffset);
        const tsMinusX = date.getTime() - 86400 * 1000 * dayMinusX;
        const dateMinusX = new Date(tsMinusX);
        return dateMinusX;
    }
    // DD dd.mm.
    getDateTimeMinusX(timeOffset, dayMinusX) {
        const days = ['SO', 'MO', 'DI', 'MI', 'DO', 'FR', 'SA', 'SO'];
        const dateMinusX = this.getDateMinusX(timeOffset, dayMinusX);
        return (days[dateMinusX.getDay()] +
            ' ' +
            this.#addZero(dateMinusX.getDate()) +
            '.' +
            this.#addZero(dateMinusX.getMonth() + 1) +
            '.');
    }
    // Gibt ISO Datum als DD.MM.YYYY zurück
    getFormatDate(date) {
        const time = new Date(date);
        // getMonth gibt die Monate von 0-11 an
        return this.#addZero(time.getDate()) + '.' + this.#addZero(time.getMonth() + 1) + '.' + time.getFullYear();
    }
    getFormatDateISO(date) {
        return (this.#addZero(date.getFullYear()) +
            '-' +
            this.#addZero(date.getMonth() + 1) +
            '-' +
            this.#addZero(date.getDate()));
    }
    // HH:MM
    getFormatTime(date) {
        const time = new Date(date);
        return this.#addZero(time.getHours()) + ':' + this.#addZero(time.getMinutes());
    }
    // Gibt ISO Datum als DD.MM.YYYY ∙ HH:MM zurück
    getFormatDateTime(date) {
        const time = new Date(date);
        // getMonth gibt die Monate von 0-11 an
        return (this.#addZero(time.getDate()) +
            '.' +
            this.#addZero(time.getMonth() + 1) +
            '.' +
            time.getFullYear() +
            ' ∙ ' +
            this.#addZero(time.getHours()) +
            ':' +
            this.#addZero(time.getMinutes()));
    }
    // Gibt ISO Datum als XX Tage // XX Stunden // XX Minuten verfügbar zurück
    getFormatRemainingTime(timeOffset, date) {
        const startDate = this.getSystemDateTime(timeOffset).getTime();
        const endDate = new Date(date).getTime();
        let timeRemaining = Math.round((endDate - startDate) / 1000);
        if (timeRemaining >= 0) {
            const days = Math.round(timeRemaining / 86400);
            if (days > 7) {
                return '';
            }
            if (days > 0) {
                return days > 1 ? 'noch ' + days + ' Tage' : 'noch ' + days + ' Tag';
            }
            timeRemaining = timeRemaining % 86400;
            const hours = Math.round(timeRemaining / 3600);
            if (hours > 0) {
                return hours > 1 ? 'noch ' + hours + ' Stunden' : 'noch ' + hours + ' Stunde';
            }
            timeRemaining = timeRemaining % 3600;
            const minutes = Math.round(timeRemaining / 60);
            if (minutes > 0) {
                return minutes > 1 ? 'noch ' + minutes + ' Minuten' : 'noch ' + minutes + ' Minute';
            }
            else {
                return 'noch > ' + minutes + ' Minute';
            }
        }
        else {
            return '';
        }
    }
    //Gibt Sekunden als MM:SS zurück
    getFormatDuration(durationSeconds) {
        const minutes = Math.floor(durationSeconds / 60);
        const seconds = durationSeconds % 60;
        return `${this.#addZero(minutes)}:${this.#addZero(seconds)}`;
    }
    getSystemDateTime(timeOffset) {
        const date = new Date();
        date.setMilliseconds(date.getMilliseconds() + timeOffset);
        return date;
    }
    #addZero(i) {
        if (i < 10) {
            return '0' + i;
        }
        return i;
    }
}
const datetime = new Datetime();
export default datetime;
